module.exports = __webpack_public_path__ + "static/boat_static-1086c28fbca89cef31867d8dd5bde072.png";